//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractCategoryModel, AbstractCategoryNavModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";


@PresenterRegistration({
   types: [AbstractCategoryNavModel]
})
@Component({
  selector: "category-nav-item",
  standalone: false,
  templateUrl: "./categories-nav-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesNavItemComponent<TCategory extends AbstractCategoryModel> {
  public data: WritableSignal<AbstractCategoryNavModel<TCategory>> =
    signal<AbstractCategoryNavModel<TCategory>>(null);
    
  public isActive = computed(() => {
    return this.data().items().some(item => item.isChecked());
  });
}
